// extracted by mini-css-extract-plugin
export default {"configblog":"configblog_ce4bb1eac52930048546"};